define('plugin/paid-attributes/view/AttributeListView',['require','plugin/product/view/ProductListView','plugin/paid-attributes/view/AttributeItemView','lib/view/UnwrapBehavior'],function (require) {

    var ProductListView = require('plugin/product/view/ProductListView');
    var AttributeItemView = require('plugin/paid-attributes/view/AttributeItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Products composite view (products container)
     *
     * @class ProductListView
     */
    return ProductListView.extend({

        template: '#paid_attribute_list_view',
        childView: AttributeItemView,
        childViewContainer: '#sb_attribute_list_container',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
    });

});
